import { render, staticRenderFns } from "./my_point.vue?vue&type=template&id=4f1b4f73&scoped=true&"
import script from "./my_point.vue?vue&type=script&lang=js&"
export * from "./my_point.vue?vue&type=script&lang=js&"
import style0 from "./my_point.vue?vue&type=style&index=0&id=4f1b4f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b4f73",
  null
  
)

export default component.exports